import { useReservationTop10Query } from '@/hooks/RQHooks/tour/main/useReservationTop10Query';
import ExperienceProductCarousel from './ExperienceProductCarousel';

export default function PurchaseTop10List() {
  const { data, isPending } = useReservationTop10Query();

  return <ExperienceProductCarousel products={data ?? []} />;
}
